import { constants } from 'http2'
import request, { IWorkspaceResponse } from '/@/api/http/request'

const API_PREFIX = '/manage/api/v1'

// 获取组织信息
export const getOrgData = async function (workspaceId: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/workspaces/get-by_id/${workspaceId}`
  const result = await request.get(url)
  return result.data
}

// 更新用户
export const updateUser = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/update-user/`
  const result = await request.put(url, body)
  return result.data
}

/**
 * 上传飞手资质（表单+文件，FormData 格式）
 * @param data FormData，包含表单字段和文件
 * @returns Promise<any>
 */
export const saveOrUpdateUserQualification = async function (body: {}) : Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/save-or-update-user-qualification`
  const result = await request.post(url, body)
  return result.data
}

// 获取用户飞手资质
export const getUserQualification = async function (userId: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/get-user-qualification/${userId}`
  const result = await request.get(url)
  return result.data
}

// 删除用户飞手资质
export const deleteUserQualification = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/delete-user-qualification/${id}`
  const result = await request.delete(url)
  return result.data
}

/**
 * 上传头像（表单+文件，FormData 格式）
 * @param data FormData，包含表单字段和文件
 * @returns Promise<any>
 */
export const uploadFiles = async function (data: FormData) : Promise<IWorkspaceResponse<any>> {
  const result = await request({
    url: `${API_PREFIX}/files/upload-files`,
    method: 'post',
    data,
  })
  return result.data
}

// 更新用户
export const updatePassword = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/update-password`
  const result = await request.post(url, body)
  return result.data
}
